import {CommandActionBase, CommandActionInterface} from "../command-action";
import {CommandResolver} from "../command-resolver";
import {GlobalServiceProvider} from "../../../providers/global.service";

export class ListCommandsAction  extends CommandActionBase implements CommandActionInterface{

  public componentName:string = "ListCommandsComponent";
  commandString:string;
  public global:GlobalServiceProvider;


  commandList:Array<string>;

  constructor(){
    super()
  }

  do(commandString?){
    this.commandString = commandString;
    this.commandList=Object.keys(CommandResolver.commandSet);
    return new Promise((resolve, reject)=>{
      resolve({commandString: this.commandString, commandAction: this})
    })
  }

  getResult(){
    debugger;
    return this.commandList;
  }

  destroy(){

  }



  public static getNew(){
    return  new ListCommandsAction();
  }

}



// WEBPACK FOOTER //
// ./src/components/commands/list-commands/list-commands-action.ts